import {swInterceptor as request} from '@adjust/dashboard-core/api/instance/sw-interceptor/sw-interceptor';

function ServiceWorkerInterceptor() {
  'ngInject';
  return {
    request
  };
}

export {ServiceWorkerInterceptor};
